import React from "react";
import "../../../styles/contactos.css";
import site from "../../../imgs/Icons/site.svg";
import tel from "../../../imgs/Icons/tel.svg";
import email from "../../../imgs/Icons/email.svg";
import time from "../../../imgs/Icons/time_black.svg";
import { withNamespaces } from 'react-i18next';

const LinhasApoio = ({t}) => {
  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }
  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_linhasApoio"
      >
        {/* 1 - SOS ESTUDANTE */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="eSos">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cESos"
              aria-expanded="true"
              aria-controls="cESos"
            >
              {t('moduleContactosEmergencia:S5.A.A1.T')}
            </button>
          </h2>
          <div
            id="cESos"
            className="accordion-collapse collapse"
            aria-labelledby="eSos"
            data-bs-parent="#accordionExample_linhasApoio"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S5.A.T')}
                  >
                    {t('moduleContactosEmergencia:S5.A.T')}
                  </a>
                </p>
                <p className="p-bold">{t('moduleContactosEmergencia:S5.A.A1.ST1.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S5.A.A1.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S5.A.A1.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEmergencia:S5.A.A1.ST1.P2')}>
                    {t('moduleContactosEmergencia:S5.A.A1.ST1.P2')}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>{t('moduleContactosEmergencia:S5.A.A1.ST1.P3')}
                  <a className="link" href={"mailto:" + t('moduleContactosEmergencia:S5.A.A1.ST1.P4')}>
                    {t('moduleContactosEmergencia:S5.A.A1.ST1.P4')}
                  </a>
                </p>
                <p className="p-bold">{t('moduleContactosEmergencia:S5.A.A1.ST2.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S5.A.A1.ST2.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S5.A.A1.ST2.P1'))}
                  </a>/{" "}
                  <a className="link" rel="noreferrer" href={"tel: +351" +
                    t('moduleContactosEmergencia:S5.A.A1.ST2.P2')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S5.A.A1.ST2.P2'))}
                  </a>/{" "}
                  <a className="link" rel="noreferrer" href={"tel: +351" +
                    t('moduleContactosEmergencia:S5.A.A1.ST2.P3')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S5.A.A1.ST2.P3'))}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S5.A.A1.ST2.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - LUA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="eLua">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cELua"
              aria-expanded="true"
              aria-controls="cELua"
            >
              {t('moduleContactosEmergencia:S5.A.A2.T')}
            </button>
          </h2>
          <div
            id="cELua"
            className="accordion-collapse collapse"
            aria-labelledby="eLua"
            data-bs-parent="#accordionExample_linhasApoio"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel: +351" +
                    t('moduleContactosEmergencia:S5.A.A2.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S5.A.A2.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S5.A.A2.ST1.P2')}
                </p>
                <p>
                  <a
                    className="link"
                    rel="noreferrer"
                    href="/processointegracao#lua"
                  >
                    {t('moduleContactosEmergencia:S5.A.A2.ST1.P3')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (LinhasApoio);
